import { observer } from 'mobx-react-lite';
import * as React from 'react';
import type { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import type { ITheme } from '@fluentui/style-utilities';
import RequiredAttendeeRow from 'owa-calendar-meeting-forms-common-view/lib/components/Attendees/RequiredAttendeeRow';
import OptionalAttendeeRow from 'owa-calendar-meeting-forms-common-view/lib/components/Attendees/OptionalAttendeeRow';
import CompactAttendeeRow from 'owa-calendar-meeting-forms-common-view/lib/components/Attendees/CompactAttendeeRow';
import {
    shouldShowCompactWell,
    shouldShowCompactReadOnlyWell,
} from 'owa-calendar-compose-form-store/lib/selectors/attendeeRowUtils';

export interface AttendeeRowsProps {
    colorScheme: ColorScheme;
    theme: ITheme;
    formId: string | null;
}

const AttendeeRows: React.FunctionComponent<AttendeeRowsProps> = props => {
    const { colorScheme, theme, formId } = props;

    if (shouldShowCompactWell() || shouldShowCompactReadOnlyWell()) {
        return <CompactAttendeeRow colorScheme={colorScheme} />;
    } else {
        return (
            <>
                <RequiredAttendeeRow colorScheme={colorScheme} theme={theme} formId={formId} />
                <OptionalAttendeeRow colorScheme={colorScheme} theme={theme} formId={formId} />
            </>
        );
    }
};

export default observer(AttendeeRows);
